<template>
    
    <a-list-item-meta
        :title="officialName"
        :description="officialDesignation"
    >
        <a-avatar
            slot="avatar"
            :size="48"
            shape="square"
            :src="officialImageUrl"
        />
    </a-list-item-meta>
    
</template>

<script>
import { mapState } from 'pinia';
import { useLocaleStore } from "../../stores/locale-store.js";

export default {
    props: {
        item: {
            type: Object,
            required: true
        } 
    },
    computed: {
        ...mapState(useLocaleStore, [ 'locale' ]),
        officialImageUrl() {
            if (this.item && this.item.imageUrl && this.item.imageUrl.length > 0)
                return this.item.imageUrl;
            return '/images/default-avatar.jpg';
        },
        officialName() {
            // console.log(this.item);
            if (this.locale == 'bn')
                if (this.item && this.item && this.item.nameBn)
                    return this.item.nameBn;
            if (this.locale == 'en')
                if (this.item && this.item && this.item.name)
                    return this.item.name;
            return '';
        },
        officialDesignation() {
            if (this.locale == 'bn')
                if (this.item && this.item && this.item.designation && this.item.designation.nameBn)
                    return this.item.designation.nameBn;
            if (this.locale == 'en')
                if (this.item && this.item && this.item.designation && this.item.designation.name)
                    return this.item.designation.name;
            return '';
        }
    }
}
</script>